import Table from "./Table";

export * from "./contexts/TableFooterContext";

export default Table;
